var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-group",
    {
      attrs: { "append-icon": _vm.appendIcon },
      model: {
        value: _vm.showing,
        callback: function($$v) {
          _vm.showing = $$v
        },
        expression: "showing"
      }
    },
    [
      _c("v-subheader", { attrs: { slot: "activator" }, slot: "activator" }, [
        _vm._v(_vm._s(_vm.subheaderText))
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf2be7a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf2be7a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/ListGroupSubheaderActivator.vue
// module id = null
// module chunks = 